import { useMemo, useState } from 'react'

import { DialogPelaksanaanAppealRollback } from 'app/KinerjaPage/pages/PelaksanaanV2/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealRollback'
import { DialogPelaksanaanAppealRequest } from 'app/KinerjaPage/pages/PelaksanaanV2/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealRequest'
import { PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS } from 'app/KinerjaShared/constants/pelaksanaanSteps'
import { LangkahObservasiCard } from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'

import type { LangkahObservasiCardProps } from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'

export const LangkahDokumenTindakLanjutCard = (
  props: LangkahObservasiCardProps
) => {
  const CURRENT_STEP = 'DOCUMENT_FOLLOW_UP'
  const currentStateOrder =
    PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[props?.state]?.order ?? -1

  const stepDeficit =
    currentStateOrder -
    PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[CURRENT_STEP].order
  const stepOrder = PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[CURRENT_STEP].order
  const [activeDialog, setActiveDialog] = useState<
    'ROLLBACK' | 'APPEAL' | 'NONE'
  >('NONE')

  const overrideState = useMemo(() => {
    if (currentStateOrder > stepOrder) return 'done'
    if (currentStateOrder === stepOrder) {
      switch (props.latestFormState) {
        case 'SUBMITTED':
          return 'done'
        case 'DRAFT':
          return props.appealState ? 'locked' : 'draft'
        case 'NOT_CREATED':
          return props.appealState ? 'locked' : 'unlocked'
        default:
          return 'unlocked'
      }
    }
    return 'locked'
  }, [currentStateOrder, props, stepOrder])

  const handleClickEdit = () => {
    if (stepDeficit === 1 && props.latestFormState === 'NOT_CREATED')
      return setActiveDialog('ROLLBACK')
    return setActiveDialog('APPEAL')
  }

  return (
    <>
      <LangkahObservasiCard
        {...props}
        overrideState={overrideState}
        currentForm={CURRENT_STEP}
        onClickEdit={handleClickEdit}
        isAppealed={props.appealState === CURRENT_STEP}
      />
      <DialogPelaksanaanAppealRollback
        isOpen={activeDialog === 'ROLLBACK'}
        onClose={() => setActiveDialog('NONE')}
        onCancel={() => setActiveDialog('NONE')}
        step={CURRENT_STEP}
        // directly to step 2
        url={`${props.url}/detail`}
      />
      <DialogPelaksanaanAppealRequest
        isOpen={activeDialog === 'APPEAL'}
        step={CURRENT_STEP}
        stepDeficit={stepDeficit}
        onClose={() => setActiveDialog('NONE')}
        initialDialogSize="md"
        headerText="Jika lanjut ubah, isi dokumen ini akan dihapus:"
        infoText="Mohon ajukan perubahan ke atasan terlebih dahulu, ya."
        confirmationText="Saya mengerti bahwa isi Dokumen Tindak Lanjut dan Dokumen Refleksi Tindak Lanjut akan dihapus dan saya harus mengulang pengisian."
      />
    </>
  )
}
